import { useMemo } from 'react'

interface UseGuildBannerLogicProps {
  areGuildTicketsAvailable: boolean
  isPremiumGuildMember: boolean
  promoType?: string
}

export const useGuildBannerLogic = ({ areGuildTicketsAvailable, isPremiumGuildMember }: UseGuildBannerLogicProps) => {
  return useMemo(() => {
    if (areGuildTicketsAvailable) {
      return {
        shouldShowGuildGiveaway: true,
        shouldShowOtherBanners: false,
      }
    }

    if (!areGuildTicketsAvailable && isPremiumGuildMember) {
      return {
        shouldShowGuildGiveaway: false,
        shouldShowOtherBanners: false,
      }
    }

    return {
      shouldShowGuildGiveaway: false,
      shouldShowOtherBanners: true,
    }
  }, [areGuildTicketsAvailable, isPremiumGuildMember])
}
